import { TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import MlmJob from '../../model/MlmJob';
import MlmFlyerConfig, { MlmFlyerQuantity, MlmFlyerShipping } from './MlmFlyerConfig';

export const MLM_FLYER_SHIPPING_STANDARD = 22;
export const MLM_FLYER_SHIPPING_RUSH = 60;

const pricing: Record<MlmFlyerQuantity, number> = {
  [MlmFlyerQuantity.QTY_25]: 95,
  [MlmFlyerQuantity.QTY_50]: 125,
  [MlmFlyerQuantity.QTY_100]: 175,
  [MlmFlyerQuantity.QTY_250]: 225,
};

export default class MlmFlyerJob extends MlmJob<typeof MlmFlyerConfig> {
  get performable() {
    return MlmFlyerConfig;
  }

  get eligible() {
    return true;
  }

  get configurable() {
    return true;
  }

  defaultValue(): ZodVersionedMetadata<(typeof MlmFlyerConfig)['schema']> {
    return {
      version: schema_latest_version(MlmFlyerConfig.schema),
      quantity: MlmFlyerQuantity.QTY_25,
    };
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    lines.push({
      id: 'quantity',
      amount: new Big(pricing[this.metadata.quantity]),
      description: `Print Flyers (${this.metadata.quantity})`,
      phase: 'completed',
      discountable: false,
      taxable: true,
    });

    switch (this.metadata.shipping) {
      case MlmFlyerShipping.STANDARD:
        lines.push({
          amount: new Big(MLM_FLYER_SHIPPING_STANDARD),
          description: 'Standard Shipping',
          discountable: false,
          phase: 'completed',
          taxable: true,
          id: 'standard',
        });
        break;
      case MlmFlyerShipping.RUSH:
        lines.push({
          amount: new Big(MLM_FLYER_SHIPPING_RUSH),
          description: 'Rush Shipping',
          phase: 'completed',
          discountable: false,
          taxable: true,
          id: 'rush',
        });
        break;
      default:
        break;
    }

    return lines;
  }
}
